import React from 'react'
import { Box } from '@mui/material'

import Identity from './Identity'
import Customer from './Customer'
import Status from './Status'

const MAP = {
  identity: Identity,
  customer: Customer,
  status: Status,
}

const Filters = ({ filters }) => {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', ml: -1, mb: -1 }}>
      {filters
        .filter((f) => !f.disabled)
        .map(({ key, props }, i) => {
          const Component = MAP[key]
          return <Component key={key} {...props} index={i} />
        })}
    </Box>
  )
}

export default Filters
